module.exports = __webpack_public_path__ + "img/c716b75.jpg";